// JavaScript Document
var browser=navigator.appName

	function homeActiveBg(ele){
		var srcElement = document.getElementById(ele);
		if (browser=="Microsoft Internet Explorer")
		  {
		  	srcElement.style.cursor="hand";
			srcElement.style.color="#1E4E8D";
			srcElement.style.backgroundImage="url(images/homepage/cp-bg-over.gif)";
		  }
	}

	
	function homeNormalBg(ele){
		var srcElement = document.getElementById(ele);
		if (browser=="Microsoft Internet Explorer"){
		srcElement.style.backgroundImage="url(images/homepage/cp-bg.gif)";
		srcElement.style.color="#707070";
		}
	}
	
	function changeFontColor(ele){
		var srcElement = document.getElementById(ele);
		if (browser=="Microsoft Internet Explorer"){
		srcElement.style.color="#1E4E8D";	
		}
	}
	
	
	function restoreFontColor(ele){
		var srcElement = document.getElementById(ele);
		if (browser=="Microsoft Internet Explorer")	{
		srcElement.style.color="#707070";
		}
	}